import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    const closeMenuOnScroll = () => isOpen && setIsOpen(false);
    window.addEventListener("scroll", closeMenuOnScroll);
    return () => window.removeEventListener("scroll", closeMenuOnScroll);
  }, [isOpen]);

  return (
    <nav className="backdrop-blur-md bg-white/40 border-b border-white/30 shadow-md fixed top-0 w-full z-50">
      <div className="w-full px-6 lg:px-12 flex justify-between items-center h-20">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/photos/1.png"
            alt="Logo"
            className="h-12 w-12 drop-shadow-sm"
          />

          <motion.span
            className="text-2xl font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent"
            whileHover={{ scale: 1.05 }}
          >
            Corehire Solutions
          </motion.span>
        </Link>

        {/* Hamburger */}
        <button
          className="md:hidden text-gray-800"
          onClick={toggleMenu}
        >
          {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-10">
          {['Home', 'About', 'Services', 'Contact'].map((item) => (
            <motion.li
              key={item}
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <Link
                to={`/${item.toLowerCase()}`}
                className="text-lg font-medium text-gray-700 hover:text-blue-600 transition"
              >
                {item}
              </Link>
            </motion.li>
          ))}
        </ul>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.ul
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-white/90 backdrop-blur-md w-full shadow-lg py-4 text-center border-t border-gray-200"
        >
          {['Home', 'About', 'Services', 'Contact'].map((item) => (
            <li key={item} className="py-3">
              <Link
                to={`/${item.toLowerCase()}`}
                className="text-lg font-semibold text-gray-800 hover:text-blue-600"
                onClick={() => setIsOpen(false)}
              >
                {item}
              </Link>
            </li>
          ))}
        </motion.ul>
      )}
    </nav>
  );
};

export default Navbar;
